export default __webpack_public_path__ + "static/media/warning--traffic-queues-likely--g1.2c06f6f5.png";